import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';

const {logger} = useBSSLogger();

const allPosts = async () => {
    const {data} = await getwpclient().post("spedizioniweb2_pagine")


    logger.debug("ottenute pagine", data)
    return data; 
}

const mappaPreventivatore = async () => {
    const {data} = await getwpclient().post("spedizioniweb2_assocpagine")

    logger.debug("ottenute mappature pagine/preventivatore", data)
    return data; 
}

const salvaMappaPreventivatore = async (body) => {
    const {data} = await getwpclient().post("spedizioniweb2_salvaassocpagine", {preventivatore: body})

    logger.debug("aggiornate mappature pagine/preventivatore", data)
    return data; 
}

export {allPosts, mappaPreventivatore, salvaMappaPreventivatore}
